const columns: Array<any> = [
  {key: "index", width: 60},
  {
    key: "name",
    title: "Tên",
    dataIndex: "name",
    rules: [{required: true, message: "Chưa nhập tên"}],
  },
  {
    key: "soTaiKhoan",
    title: "Số tài khoản",
    dataIndex: "soTaiKhoan",
    align: "center",
  },
  {key: "nganHang", title: "Ngân hàng", dataIndex: "nganHang", align: "center"},
  {
    key: "maSoThue",
    title: "Mã số thuế",
    dataIndex: "maSoThue",
    align: "center",
  },
  {key: "diaChi", title: "Địa chỉ", dataIndex: "diaChi"},
  {
    key: "soDienThoai",
    title: "Số điện thoại",
    dataIndex: "soDienThoai",
    align: "center",
  },
  {key: "moTa", title: "Mô tả", dataIndex: "moTa"},
  {key: "action", width: 60},
];
export {columns};
